import "./Supplier360.scss";
import React from "react";
import {observer} from "mobx-react-lite";
import {Box, Typography} from "@mui/material";
import {StorefrontOutlined} from "@mui/icons-material";
import {MainPageFacade} from "../../components/main/page/MainPageFacade.tsx";
import {CARD_CONFIG} from "../../components/dashboard/DashboardCardConfigs.tsx";
import {SupplierListPanel} from "./components/SupplierListPanel";
import {SupplierDetailPanel} from "./components/SupplierDetailPanel";
import {getSupplier360List} from "./supplier360DemoData";

/**
 * Supplier 360 cockpit.
 *
 * A supplier-centric workspace: pick a supplier on the left and explore its
 * transactions, contracts, news, opportunities and risks on the right.
 * Backed by self-contained demo data (see supplier360DemoData.ts).
 */
export const Supplier360Page: React.FC = observer(() => {
    const suppliers = React.useMemo(() => getSupplier360List(), []);
    const [selectedId, setSelectedId] = React.useState<string | null>(suppliers[0]?.id ?? null);

    const selected = React.useMemo(
        () => suppliers.find(s => s.id === selectedId) ?? null,
        [suppliers, selectedId],
    );

    return <MainPageFacade
        title={CARD_CONFIG['supplier-360'].title}
        className="supplier-360-page">
        <div className="s360-layout">
            <SupplierListPanel
                suppliers={suppliers}
                selectedId={selectedId}
                onSelect={setSelectedId}
            />
            {selected
                ? <SupplierDetailPanel supplier={selected}/>
                : <Box className="s360-empty-detail">
                    <StorefrontOutlined sx={{fontSize: 48, opacity: 0.4}}/>
                    <Typography variant="h3">Select a supplier</Typography>
                    <Typography variant="body2">
                        Choose a supplier from the list to explore their 360° profile.
                    </Typography>
                </Box>
            }
        </div>
    </MainPageFacade>;
});
